import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpSentEvent,
  HttpHeaderResponse,
  HttpProgressEvent,
  HttpResponse,
  HttpUserEvent,
} from "@angular/common/http";
import { Observable } from "rxjs";

export class NoCacheInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<
    | HttpSentEvent
    | HttpHeaderResponse
    | HttpProgressEvent
    | HttpResponse<any>
    | HttpUserEvent<any>
  > {
    const nextReq = req.clone({
      headers: req.headers
        .set("Cache-Control", "no-cache")
        .set("Pragma", "no-cache")
        .set("Expires", "Sat, 01 Jan 2000 00:00:00 GMT")
        .set("If-Modified-Since", "0"),
    });

    return next.handle(nextReq);
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/no-cache-interceptor/no-cache.interceptor.ts